<template>
  <div class="licenses">
    <b-card>
      <LicensesForm
        :plans="plans"
        :companyLicenses="companyLicenses"
        @chosen="chosenPlan"
      />
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LicensesForm from '@/views/Home/Account/LicensesForm.vue'

function getBreadcrumb(labels) {
  const breadcrumb = [
    {
      label: labels.account,
      link: '/account',
    },
    {
      label: labels.licenses,
    },
  ]
  return breadcrumb
}

export default {
  components: { LicensesForm },
  computed: {
    ...mapGetters({
      resources: 'resources',
      plans: 'account/plans',
      companyLicenses: 'company/licenses',
    }),

    labels: function() {
      return {
        ...this.resources.general.menu,
        ...this.resources.page.home.accountGeneric,
      }
    },
  },

  methods: {
    ...mapActions({
      loadPlans: 'account/loadPlans',
      setPlan: 'account/setPlan',
      loadLicenses: 'company/loadLicenses',
    }),
    chosenPlan: function({ licenses, period }) {
      this.setPlan({ licenses, period })
      this.$router.push({ name: 'account.charging' })
      this.$root.$emit('track:checkout', {
        event: 'plano escolhido',
        data: { licenses, period },
      })
    },
  },
  async beforeMount() {
    const breadcrumb = getBreadcrumb(this.labels)
    const period = this.$route.params.period || null

    if (!['monthly', 'annuity'].includes(period)) {
      this.$router.push({
        name: 'account.licenses',
        params: { period: 'monthly' },
      })
    }

    this.loadPlans()
    this.loadLicenses()
    this.$root.$emit('set-breadcrumb', breadcrumb)
    this.$root.$emit('track:checkout', { event: 'Abriu form mensal' })
  },
  mounted() {
    this.$root.$emit('setPageTitle', {
      context: this,
      path: 'account/licenses',
    })
  },
}
</script>

<style lang="scss" scoped>
.card {
  padding: 0;

  .card-body {
    padding: 0;
  }
}
</style>
